// extracted by mini-css-extract-plugin
export default {"input":"base-input_input__r0mun"};